/**
 * Single source of truth for which authentication flow is active.
 *
 * Two modes:
 *   - 'msal' : real Entra OIDC via MSAL.js. The SPA obtains a Bearer
 *              token via redirect flow; api.ts attaches it as
 *              Authorization: Bearer <token> on every request.
 *   - 'dev'  : the legacy `X-Dev-User: <email>` header path. No real
 *              authentication — backend looks the email up in the
 *              users table and trusts it. Only works when the backend
 *              is started with DEBUG=true (rejected in prod).
 *
 * Used by:
 *   - Login.tsx  : picks the right login UI (Microsoft button vs preset list)
 *   - api.ts     : picks the right auth header
 *   - main.tsx   : decides whether to wrap with <MsalProvider>
 *   - AppShell.tsx : decides what gates the /me fetch (devUser or msalAccount)
 *
 * The mode is determined by a single env-var check inside lib/msal.ts;
 * this module just re-exports the decision under a clearer name.
 */
import { isMsalActive } from '@/lib/msal';
export function currentAuthMode() {
    return isMsalActive() ? 'msal' : 'dev';
}
